import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { BRAND_CLASSES } from '@/constants/theme';
import { Loader2 } from 'lucide-preact';
/**
 * Standardized form action buttons (Save/Cancel) for modal forms
 * Provides consistent styling, loading states, and behavior across all forms
 *
 * @example
 * // Basic usage
 * <FormActions
 *   isSubmitting={isSubmitting}
 *   isSaveDisabled={!isValid}
 *   onCancel={handleClose}
 * />
 *
 * @example
 * // With custom text and back button
 * <FormActions
 *   isSubmitting={isSubmitting}
 *   isSaveDisabled={!canProceed}
 *   onCancel={handleClose}
 *   saveText="Create Campaign"
 *   showBackButton={step === 2}
 *   onBack={() => setStep(1)}
 * />
 */
export function FormActions({ isSubmitting, isSaveDisabled, onCancel, saveText, cancelText = 'Cancel', showBackButton = false, onBack, onSaveClick, formId, className = '', leftActions, rightActions, }) {
    const defaultSaveText = isSubmitting ? 'Saving...' : 'Save';
    const displaySaveText = saveText || defaultSaveText;
    return (_jsxs("div", { className: `flex items-center justify-between gap-3 p-6 border-t border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-700/50 ${className}`, children: [_jsxs("div", { className: "flex items-center gap-3", children: [showBackButton && onBack && (_jsx("button", { type: "button", onClick: onBack, disabled: isSubmitting, className: "px-4 py-2 text-sm font-medium text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-slate-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed", children: "Back" })), leftActions] }), _jsxs("div", { className: "flex items-center gap-3 ml-auto", children: [rightActions, _jsx("button", { type: "button", onClick: onCancel, disabled: isSubmitting, className: "px-4 py-2 text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-600 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed", children: cancelText }), _jsxs("button", { type: onSaveClick ? 'button' : 'submit', onClick: onSaveClick, form: onSaveClick ? undefined : formId, disabled: isSaveDisabled || isSubmitting, className: `px-6 py-2 rounded-lg transition-colors flex items-center gap-2 ${BRAND_CLASSES.BUTTON.PRIMARY} disabled:opacity-50 disabled:cursor-not-allowed`, children: [isSubmitting && (_jsx(Loader2, { className: "w-4 h-4 animate-spin" })), displaySaveText] })] })] }));
}
